import { useTranslation } from 'react-i18next';
import { PageHeader } from '@shared/layout/PageHeader';
import { Card, CardContent } from '@shared/ui/card';

interface PlaceholderPageProps {
  title: string;
  hint?: string;
}

/**
 * Marker for routes that exist in routing but whose feature is not yet built.
 * Keeps navigation honest: the user can see what's coming.
 */
export function PlaceholderPage({ title, hint }: PlaceholderPageProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={title} />
      <div className="p-4">
        <Card>
          <CardContent className="space-y-2 p-6 text-center">
            <p className="text-base font-medium">{t('placeholder.comingSoon')}</p>
            {hint ? <p className="text-sm text-muted-foreground">{hint}</p> : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
}
